import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-218ac164"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "saleFormProp"
};
var _hoisted_2 = {
  class: "mb-2 table cus-table"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("tr", {
    class: "th"
  }, [/*#__PURE__*/_createElementVNode("th", null, "料类"), /*#__PURE__*/_createElementVNode("th", null, "销量"), /*#__PURE__*/_createElementVNode("th", null, "销售额")], -1);
});
var _hoisted_4 = {
  key: 1
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("td", {
    colspan: "5"
  }, "暂无数据", -1);
});
var _hoisted_6 = [_hoisted_5];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("table", _hoisted_2, [_hoisted_3, _ctx.saleData.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.saleData, function (item, index) {
    return _openBlock(), _createElementBlock("tr", {
      key: index
    }, [_createElementVNode("td", null, _toDisplayString(item.name), 1), _createElementVNode("td", null, _toDisplayString(item.value), 1), _createElementVNode("td", null, _toDisplayString(item.price), 1)]);
  }), 128)) : (_openBlock(), _createElementBlock("tr", _hoisted_4, _hoisted_6))])]);
}